export const game = createInitialGameState();

export function createInitialGameState() {
  return {
    mode: 'playing',
    wave: 1,
    score: 0,
    kills: 0,
    comboKills: 0,
    health: 100,
    maxHealth: 100,
    streak: 1,
    xp: 0,
    level: 1,
    xpToLevel: 18,
    elapsed: 0,
    dashCooldown: 0,
    spawnQueue: [],
    upgrades: {
      moveSpeed: 0,
      damage: 0,
      fireRate: 0,
      bulletSize: 0,
      pellets: 0,
      pierce: 0,
      ricochet: 0,
      orbitals: 0,
      skyLaser: 0,
      freezeAura: 0,
      chainLightning: 0,
      stormCall: 0,
      deathNova: 0,
      vampire: 0,
      regen: 0,
      barrier: 0,
      explode: 0,
      freeze: 0,
      critChance: 0,
      critDamage: 0,
      bulletSpeed: 0,
      stagger: 0,
      execute: 0,
      overdriveGain: 0,
      mercy: 0,
      blackHole: 0,
      bladeAura: 0,
      meteorRain: 0,
      shockWeb: 0,
    },
    boss: null,
    mapTier: 0,
    mapSize: 72,
    generatedSquares: 1,
    mapSector: 'Core Block',
    sectorThreat: 1,
    biome: 'alley',
    pacingPhase: 'lull',
    waveIntroTimer: 0,
    mercyTimer: 0,
    spawnMultiplier: 1,
    daily: null,
    overdriveTime: 0,
    overdriveCharge: 0,
    ads: false,
    timeScale: 1,
    shakeEnabled: true,
    shakeIntensity: 1,
  };
}

export function resetGame(overrides = {}) {
  Object.keys(game).forEach((key) => delete game[key]);
  Object.assign(game, createInitialGameState(), overrides);
  return game;
}

export function setGameMode(mode) {
  game.mode = mode;
  return game.mode;
}

export function addScore(amount) {
  game.score += Math.max(0, Math.floor(amount || 0));
  return game.score;
}

export function addKill() {
  game.kills += 1;
  game.comboKills += 1;
  game.streak = Math.max(1, game.comboKills);
  game.overdriveCharge = Math.min(100, game.overdriveCharge + 4 * (1 + (game.upgrades.overdriveGain || 0)));
  return game.kills;
}

export function damagePlayer(amount) {
  if (game.mercyTimer > 0) return game.health;
  game.health = Math.max(0, game.health - Math.max(0, amount || 0));
  game.comboKills = 0;
  game.streak = 1;
  if (game.health <= 0) game.mode = 'gameover';
  return game.health;
}
